export default "__VITE_ASSET__DSZzAeTn__"